export default __webpack_public_path__ + "static/media/5.6a33098d.png";